/*
*   File : creator-slider.js
*   Author : https://evoqins.com
*   Description : Slider component of creator
*   Integrations : NA
*   Version : 1.0.0
*/

import { forwardRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

//Custom component
import { CreatorCard } from '../../Component/Cards';

const CreatorSlider = forwardRef((props, ref) => {
    return (
        <Swiper ref={ref}
            // slidesPerView={2.75}
            spaceBetween={16}
            className='z-0'
            navigation={true}
            modules={[Navigation]}
            mousewheel={true}
            breakpoints={{
                768: {   // when window width is >= 576px
                    slidesPerView: 2.75,
                    spaceBetween: 16,
                },
                576: {   // when window width is >= 576px
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                400: {   // when window width is >= 400px
                    slidesPerView: 1.2,
                    spaceBetween: 8,
                },
                320: {   // when window width is >= 320px
                    slidesPerView: 1,
                    spaceBetween: 8,
                },
            }}>

            {
                props.data.length && props.data.map((items, key) => (
                    <SwiperSlide key={key}>
                        <CreatorCard creator={items}
                            handleClick={props.handleClick} />
                    </SwiperSlide>
                ))}

        </Swiper>
    )
});

export default CreatorSlider;
